export default {
    AUTH_FEATURE_FLAGS__REQUEST_START: 'AUTH_FEATURE_FLAGS__REQUEST_START',
    AUTH_FEATURE_FLAGS__REQUEST_SUCCESS: 'AUTH_FEATURE_FLAGS__REQUEST_SUCCESS',
    AUTH_FEATURE_FLAGS__REQUEST_REJECT: 'AUTH_FEATURE_FLAGS__REQUEST_REJECT',
};
